import Link from 'next/link'

/**
 * 記事ページの参考文献欄の直下に表示する支援導線。
 * 参考文献のAmazonアソシエイトリンクに対する広告表示も兼ねる。
 */
export const SupportNotice = () => (
  <p className="fs-7 text-muted border-top pt-3 mt-5 mb-0 d-print-none">
    Mathpediaは寄付と、参考文献の書籍リンク（Amazonアソシエイト）の紹介料で運営されています。{' '}
    <Link href="/support" passHref>
      <a>支援について</a>
    </Link>
    {' ／ '}
    <a href="https://buy.stripe.com/4gM6oJ2XbfwGd9E5SKdIA00" rel="nofollow">
      寄付する
    </a>
  </p>
)
